import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Action from './Modules.Action.record';
import { Form, Row, Col, Select, Input, DatePicker, Button, Checkbox } from 'antd';
import moment from 'moment';
const css = require('./index.scss');
const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;
/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/**  */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class AuthRecordFilter extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    onChange = () => {

    }
    render() {
        const formItemLayout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 19 }
        };
        const { form: { getFieldDecorator } } = this.props;
        const options = [
            { label: '认证中', value: '1' },
            { label: '处理完毕', value: '2' }
        ];
        const types = [
            { label: '抵扣认证', value: 1 },
            { label: '退税认证', value: 2 }
        ];
        let { filter } = this.modulesState.record.p1;
        return (
            <div style={{ padding: 10 }}>
                <Form onSubmit={this.handleFilter} >
                    <FormItem
                        label="提交时间"
                        {...formItemLayout}
                    >
                        <Col span={11}>
                            <FormItem>
                                {getFieldDecorator('minQueryTime', {
                                    initialValue: filter && filter.minQueryTime
                                })(
                                    <DatePicker style={{ width: '100%', minWidth: 'auto' }} format="YYYY-MM-DD HH:mm" showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }} />
                                )}
                            </FormItem>
                        </Col>
                        <Col span={2}>
                            <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                -
                            </span>
                        </Col>
                        <Col span={11}>
                            <FormItem>
                                {getFieldDecorator('maxQueryTime', {
                                    initialValue: filter && filter.maxQueryTime
                                })(
                                    <DatePicker style={{ width: '100%', minWidth: 'auto' }} format="YYYY-MM-DD HH:mm" showTime={{ defaultValue: moment('23:59:59', 'HH:mm:ss') }} />
                                )}
                            </FormItem>
                        </Col>
                    </FormItem>
                    <FormItem {...formItemLayout} label={`备注信息`}>
                        {getFieldDecorator('batchNote', {
                            initialValue: filter && filter.batchNote
                        })(
                            <Input />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label={`认证状态`}>
                        {getFieldDecorator('authEndFlag', {
                            initialValue: filter && filter.authEndFlag
                        })(
                            <CheckboxGroup options={options} onChange={this.onChange} />
                        )}
                    </FormItem>
                    <FormItem {...formItemLayout} label={`认证类型`}>
                        {getFieldDecorator('authType', {
                            initialValue: filter && filter.authType
                        })(
                            <CheckboxGroup options={types} onChange={this.onChange} />
                        )}
                    </FormItem>
                    <Col span={24} className="text-right">
                        <Button className="mr10" onClick={this.handleReset}>清空</Button>
                        <Button type="primary" htmlType="submit">筛选</Button>
                    </Col>
                </Form>
            </div>
        );
    }
    private handleFilter = (e: any) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            let { p1 } = this.modulesState.record;
            let flag = values['authEndFlag'];
            let type = values['authType'];
            p1.filter = values;
            p1.list = [];
            p1.pageNum = 1;
            p1.hasMore = true;
            p1.loading = false;
            if (values['authEndFlag'] && values['authEndFlag'].length === 2) {
                flag = null;
            }
            if (type && type.length === 2) {
                type = null;
            }
            p1.fields = {
                'authEndFlag': flag,
                'authType': type,
                'minQueryTime': values['minQueryTime'] && values['minQueryTime'].format('YYYY-MM-DD HH:mm:ss'),
                'maxQueryTime': values['maxQueryTime'] && values['maxQueryTime'].format('YYYY-MM-DD HH:mm:ss'),
                'batchNote': values['batchNote']
            };
            ModulesAction.setModulesState().then(() => {
                Action.getData();
            });
        });
    }
    private handleReset = () => {
        this.props.form.resetFields();
        this.modulesState.record.p1.filter = null;
        this.modulesState.record.p1.fields = null;
        ModulesAction.setModulesState();
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.AuthRecord.Filter.tsx